import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, Button, InputGroup, Form, Pagination } from "react-bootstrap";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import UploadImageComponent from "../UploadImageComponent";
import imgWarning from "../../assets/alert-warning.png";
import convertNumber from "../../helpers/convertNumber";
import { END_IMAGE } from "../../constants";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import ReactPaginate from "react-paginate";
import getOneLatest from "../../helpers/getOneLatest";
import { get_activity_history_record } from "../../services/balance.service";
import { useStore } from "../../store";
import LoadingComponent from "../LoadingComponent";
let limitData = 1;

export default function PopUpDetailInstallment({
  open,
  onClose,
  installmentData,
  memberData,
  onClickEdit,
  onClickDelete,
}) {
  console.log("installmentData", installmentData);
  // state
  const [dropdown, setDropdown] = useState(false);
  const [pagination, setPagination] = useState(1);
  const [totalPagination, setTotalPagination] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [installmentRecordData, setInstallmentRecordData] = useState();
  const [selectInstallment, setSelectInstallment] = useState();

  // store
  const { token, branchData } = useStore();

  // useEffect
  useEffect(() => {
    setDropdown(false);
    setPagination(1);
  }, [open]);
  useEffect(() => {
    if (installmentData) {
      getData();
    }
  }, [installmentData, pagination]);

  // function
  const getData = async () => {
    try {
      setIsLoading(true);
      if (!installmentData) throw new Error("installmentData empty");
      if (!installmentData?._id) throw new Error("activityHistoryId empty");

      let skipData = (pagination - 1) * limitData;
      const _data = await get_activity_history_record(
        installmentData?._id,
        skipData,
        limitData,
        token
      );
      setInstallmentRecordData(_data);
      console.log("data", _data);
      setTotalPagination(Math.ceil(_data?.total / limitData));

      setInstallmentRecordData(getOneLatest(_data?.data));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error.message);
    }
  };

  return (
    <Modal show={open} onHide={onClose} size="sm" centered>
      {isLoading ? (
        <>
          <Modal.Header
            closeButton
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontWeight: 700,
            }}
          >
            <div>ລາຍລະອຽດ</div>
          </Modal.Header>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              minHeight: 400,
            }}
          >
            <LoadingComponent />
          </div>
        </>
      ) : (
        <>
          <Modal.Header
            closeButton
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontWeight: 700,
            }}
          >
            <div>ລາຍລະອຽດ</div>
            <div style={{ flex: 1 }}></div>
          </Modal.Header>
          <Modal.Body
            style={{
              boxSizing: "border-box",
              overflow: "auto",
              width: "100%",
              padding: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 20,
                marginBottom: 20,
              }}
            >
              {[
                {
                  title: "ງວດທີ:",
                  value: installmentData?.installmentNoteNo || "-",
                },
                {
                  title: "ຊື່ບັນຊີ:",
                  value: memberData?.fullName || "-",
                },
                {
                  title: "ຈຳນວນເງິນ (ກີບ):",
                  value: installmentData?.totalRepayment
                    ? convertNumber(installmentData?.totalRepayment)
                    : "-",
                },
                {
                  title: "ຄ່າປັບໃໝ (ກີບ):",
                  value: installmentData?.lateFeesAmount
                    ? convertNumber(installmentData?.lateFeesAmount)
                    : "-",
                },
                {
                  title: "ລາຍລະອຽດ:",
                  value: "-",
                },
                {
                  title: "ວັນເວລາທີ່ຕ້ອງຊຳລະ:",
                  value: installmentData?.dueDate
                    ? moment(installmentData?.dueDate).format(
                        "DD/MM/YYYY HH:mm"
                      )
                    : "-",
                },
                {
                  title: "ວັນເວລາຊຳລະຕົວຈິງ:",
                  value: installmentData?.paymentDate
                    ? moment(installmentData?.paymentDate).format(
                        "DD/MM/YYYY HH:mm"
                      )
                    : "-",
                },
                {
                  title: "ຜູ້ສ້າງລາຍການ:",
                  value: installmentData?.updatedBy?.fullName || "-",
                },
              ].map((e, i) => (
                <div className="list-data" key={i}>
                  <div>{e?.title}</div>
                  <div>{e?.value}</div>
                </div>
              ))}
            </div>
            <label>ຮູບພາບຢືນຢັນ</label>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 8,
                overflow: "hidden",
                maxHeight: 200,
              }}
            >
              <Zoom>
                <img
                  src={END_IMAGE + installmentData?.installmentImage}
                  alt=""
                  style={{ width: "100%" }}
                />
              </Zoom>
            </div>
            {/* DOING: ປະຫວັດການແກ້ໄຂ ແລະ ປະຫວັດການລົບ */}
          </Modal.Body>
        </>
      )}
      {/* <Modal.Footer>
        <div
          style={{
            display: isLoading ? "none" : "flex",
            justifyContent: "center",
            width: "100%",
            bottom: 20,
          }}
        >
          <ReactPaginate
            previousLabel={
              <span className="glyphicon glyphicon-chevron-left">{`<`}</span>
            }
            nextLabel={
              <span className="glyphicon glyphicon-chevron-right">{`>`}</span>
            }
            breakLabel={<Pagination.Item disabled>...</Pagination.Item>}
            breakClassName={"break-me"}
            pageCount={totalPagination} // Replace with the actual number of pages
            marginPagesDisplayed={1}
            pageRangeDisplayed={4}
            onPageChange={(e) => {
              setPagination(e?.selected + 1);
            }}
            containerClassName={"pagination justify-content-center"} // Bootstrap class for centering
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            activeClassName={"active"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
          />
        </div>
      </Modal.Footer> */}
    </Modal>
  );
}

